import * as z from "zod/v4";

export const deleteLinearComment = {
  name: "deleteLinearComment" as const,
  input: z.object({ linearTicketId: z.string(), commentId: z.string() }),
  output: z.object({
    success: z.boolean(),
    slackSuccess: z.boolean(),
    error: z.string().optional(),
  }),
};
